import React from 'react';
import classNames from 'classnames';
import { CloseIcon } from '../../icons/close-icon';
import { useTranslate } from '../../../context/api-context/translations/use-translate';
import TextExtended from '../../text-extended/text-extended';
import { UserIcon } from '../../icons/user-icon';
import { UserGroupIcon } from '../../icons/user-group-icon';
import { useConfiguration } from '../../../context/configuration-context/use-configuration';
import ViewportIosContainer from '../../ios-viewport-container/ios-viewport-container';
import styles from './anonymous-publish-sheet-modal.scss';
import { ANONYMOUS_PUBLISH_SHEET, CANCEL_BTN, PUBLISH_AS_GUEST_BTN, PUBLISH_AS_MEMBER_BTN, } from '../../../../common/constants/data-hooks';
const ActionItem = ({ label, onClick, icon: Icon, dataHook, isBw }) => {
    return (React.createElement("div", { "data-hook": dataHook, className: styles.actionItem, onClick: onClick },
        Icon && React.createElement(Icon, { className: classNames(styles.actionIcon, { 'wc-icon-fill': !isBw }) }),
        React.createElement(TextExtended, { className: styles.actionLabel, priority: isBw ? 'black' : 'primary' }, label)));
};
const AnonymousPublishSheetModal = ({ toggle, onPublish }) => {
    const t = useTranslate();
    const { blackAndWhiteModals, hideActionMenusIcons } = useConfiguration();
    const isBw = blackAndWhiteModals === true;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.overlay, onClick: toggle }),
        React.createElement(ViewportIosContainer, { preventScroll: false, className: styles.contentContainer },
            React.createElement("div", { "data-hook": ANONYMOUS_PUBLISH_SHEET, className: classNames(styles.innerContainer, { 'wc-bg-color': !isBw }) },
                React.createElement(ActionItem, { isBw: isBw, dataHook: PUBLISH_AS_MEMBER_BTN, label: t('anonymous-publish-sheet-modal.publish-as-member'), onClick: () => {
                        onPublish({ asGuest: false });
                        toggle();
                    }, icon: UserGroupIcon }),
                React.createElement(ActionItem, { isBw: isBw, dataHook: PUBLISH_AS_GUEST_BTN, label: t('anonymous-publish-sheet-modal.publish-as-guest'), onClick: () => {
                        onPublish({ asGuest: true });
                        toggle();
                    }, icon: UserIcon }),
                React.createElement(ActionItem, { isBw: isBw, dataHook: CANCEL_BTN, icon: !hideActionMenusIcons && CloseIcon, label: t('anonymous-publish-sheet-modal.publish-cancel'), onClick: toggle })))));
};
export default AnonymousPublishSheetModal;
//# sourceMappingURL=anonymous-publish-sheet-modal.js.map